/** Major covered cities for instant dropdown suggestions (display casing). */
export const COVERED_CITIES = [
  'San Francisco',
  'San Jose',
  'Oakland',
  'Berkeley',
  'Palo Alto',
  'Sunnyvale',
  'Santa Clara',
  'Cupertino',
  'Mountain View',
  'San Mateo',
  'Fremont',
  'Redwood City',
  'Menlo Park',
  'Campbell',
  'Los Gatos',
  'Milpitas',
  'Saratoga',
  'Los Altos',
  'Gilroy',
  'Morgan Hill',
  'Santa Cruz',
  'Salinas',
  'Watsonville',
  'Hollister',
  'Half Moon Bay',
] as const;

/**
 * Cities whose name starts with the query (case-insensitive), best-first.
 * Instant (no network) — the autocomplete API only returns addresses.
 */
export function matchCities(query: string, limit = 2): string[] {
  const q = query.trim().toLowerCase();
  if (q.length < 2) return [];
  return COVERED_CITIES.filter((c) => c.toLowerCase().startsWith(q)).slice(0, limit);
}
